import axios from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    fcmToken: null,
    notifications: [],
    unreadQty: 0,
    enabled: false,
    enabledChecked: false,
    permissions: '',
    enableSubmitting: false,
    permissionSubmitting: false,
  },
  getters: {
    fcmToken: state => state.fcmToken,
    notifications: state => state.notifications,
    unreadQty: state => state.unreadQty,
    status: state => state.status,
  },
  mutations: {
    SET_FCM_TOKEN(state, val) {
      state.fcmToken = val
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },
    SET_UNREAD_QTY(state, qty) {
      state.unreadQty = qty
    },
    DECREASE_UNREAD_QTY(state, qty) {
      state.unreadQty = Math.max(0, state.unreadQty - qty)
    },
    SET_NOTIFICATIONS_ENABLED(state, enabled) {
      state.enabled = enabled
    },
    SET_ENABLED_CHECKED(state, payload) {
      state.enabledChecked = payload
    },
    DELETE_NOTIFICATION_DATA(state) {
      state.notifications = []
      state.unreadQty = 0
    },
    SET_ENABLE_SUBMITTING(state, payload) {
      state.enableSubmitting = payload
    },
    SET_PERMISSION_SUBMITTING(state, isSubmitting) {
      state.permissionSubmitting = isSubmitting
    },
    SET_PERMISSIONS(state, permission) {
      state.permissions = permission
    },
  },
  actions: {
    async fetchUnreadQty(ctx) {
      const response = await axios.get('/notifications', {
        params: { unread: 'unread', page: 1, per_page: 1, order: 'desc' },
      }).catch(error => {
        if (error?.response?.status === 404) return error.response
        console.log(error)
      })

      const successStatuses = [200, 201]
      if (response && successStatuses.includes(response.status)) {
        ctx.commit('SET_UNREAD_QTY', response.data?.meta?.total ?? 0)
      }

      return response
    },
    async fetchNotifications(ctx, queryParams) {
      const response = await axios.get('/notifications', {
        params: queryParams,
      }).catch(error => {
        if (error.response.status === 404) {
          return error.response
        }
        console.log(error)
      })
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        if(queryParams.unread==='unread'){
          ctx.commit('SET_UNREAD_QTY', response.data.meta.total)
        }
        ctx.commit('SET_NOTIFICATIONS', response.data.data)
      }
      return response
    },
    async readNotification(ctx, id) {
      return axios.post(`/notifications/${id}/read`).catch(error => {
        if (error.response.status === 404) {
          return error.response
        }
        console.log(error)
      })
    },
    async readAllNotifications(ctx) {
      return axios.post('/notifications/read-all').catch(error => {
        if (error.response.status === 404) {
          return error.response
        }
        console.log(error)
      })
    },
    async addFcmToken(ctx, data) {
      return axios.post('/notifications/fcm-tokens', data)
    },

    async replaceFcmToken(ctx, data) {
      return axios.post('/notifications/fcm-tokens/replace', {
        old_token: data.oldToken,
        new_token: data.newToken,
      }).catch(error => console.log(error))
    },

    async fetchFcmTokens(ctx, data) {
      return axios.get('/notifications/fcm-tokens', )
    },

    async checkFcmToken(ctx, data) {
      return  axios.post('/notifications/fcm-tokens/check', data )
    },

  },
}
